import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 px-4 border-t border-zinc-900 text-center" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <div className="text-2xl font-space-grotesk font-bold mb-4 flex items-center justify-center gap-2" data-id="element-97">
          <span data-id="element-98">🏋️</span> COMPRA DIGITAL YA™
        </div>

        <p className="text-zinc-400 mb-2" data-id="element-99">
          El sistema N°1 para profes de E. Funcional en Argentina.
        </p>
        <p className="text-zinc-500 text-sm mb-8" data-id="element-100">
          Porque dar buenas clases no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-zinc-400 mb-12" data-id="element-101">
          <a href="mailto:compradigitalyaa@gmail.com" className="hover:text-white transition-colors" data-id="element-102">
            📧 compradigitalyaa@gmail.com
          </a>
          <span className="hidden md:inline text-zinc-800" data-id="element-103">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-104">
            🌐 www.compradigitalya.com
          </a>
        </div>

        <div className="text-xs text-zinc-600 space-y-2" data-id="element-105">
          <p data-id="element-106">© Compra Digital Ya™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-107">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 text-zinc-800 text-sm font-space-grotesk font-bold" data-id="element-108">
          🏋️ "El próximo domingo podés abrirlo, leerlo y ejecutarlo." "Cero
          estrés. Cero improvisación. Clases que funcionan."
        </div>
      </div>
    </footer>;
}